import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=483d23e0"
import script from "./Usuarios.vue?vue&type=script&lang=ts"
export * from "./Usuarios.vue?vue&type=script&lang=ts"
import style0 from "./Usuarios.vue?vue&type=style&index=0&id=483d23e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports